/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import { COMPANY } from "./_company";

export default function CGV() {
  return (
    <LegalLayout
      eyebrow="Boutique"
      title="Conditions générales de vente"
      lastUpdated={COMPANY.effectiveDate}
      intro="Les présentes conditions régissent toute commande passée sur la boutique BAYO. Toute commande implique l'acceptation pleine et entière des présentes CGV."
    >
      <h2>1. Identification du vendeur</h2>
      <p>
        Le vendeur est <strong>{COMPANY.name}</strong>, {COMPANY.legalForm}, immatriculée sous le numéro{" "}
        {COMPANY.registration}, dont le siège est situé au {COMPANY.address}. Email :{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>

      <h2>2. Produits</h2>
      <p>
        BAYO commercialise sur son site deux catégories de produits :
      </p>
      <ul>
        <li>
          <strong>Produits physiques</strong> : épices, ustensiles, livres papier — expédiés selon les
          conditions précisées dans notre <a href="/legal/livraison">page Livraison</a>.
        </li>
        <li>
          <strong>Produits numériques</strong> : ebooks PDF — délivrés instantanément après paiement
          confirmé, par téléchargement depuis l'espace client et par email.
        </li>
      </ul>
      <p>
        Les caractéristiques essentielles, le prix TTC, les frais de livraison et les modalités de
        paiement sont indiqués sur chaque fiche produit avant validation de la commande.
      </p>

      <h2>3. Prix et paiement</h2>
      <p>
        Les prix sont exprimés en euros, toutes taxes comprises (TVA française applicable). BAYO se
        réserve le droit de modifier ses prix à tout moment, étant entendu que le prix figurant au
        catalogue le jour de la commande sera le seul applicable à l'acheteur.
      </p>
      <p>
        Les paiements sont sécurisés par notre partenaire <strong>Stripe</strong> (cartes Visa,
        Mastercard, American Express). Aucune donnée de carte bancaire n'est conservée par BAYO.
        Le débit est effectué au moment de la validation de la commande.
      </p>

      <h2>4. Code promo et parrainage</h2>
      <p>
        Les utilisateurs disposent d'un code de parrainage unique. Tout filleul nouvellement inscrit
        bénéficie d'une remise de <strong>-10 %</strong> applicable une seule fois sur sa première
        commande payée. La remise est appliquée automatiquement au moment du paiement et n'est pas
        cumulable avec d'autres opérations promotionnelles.
      </p>

      <h2>5. Disponibilité</h2>
      <p>
        Les offres de produits sont valables tant qu'elles sont visibles sur le Site, dans la limite
        des stocks disponibles. En cas d'indisponibilité après commande, BAYO en informera l'acheteur
        dans les meilleurs délais et procédera, le cas échéant, au remboursement intégral.
      </p>

      <h2>6. Livraison</h2>
      <p>
        Les modalités, délais et frais de livraison sont détaillés dans notre{" "}
        <a href="/legal/livraison">page Livraison</a>.
      </p>

      <h2>7. Droit de rétractation</h2>
      <p>
        Conformément aux articles L221-18 et suivants du Code de la consommation, l'acheteur dispose
        d'un délai de <strong>{COMPANY.returnDays} jours</strong> à compter de la réception du produit
        physique pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer
        de pénalités.
      </p>
      <p>
        <strong>Exception (article L221-28 13° du Code de la consommation) :</strong> le droit de
        rétractation <em>ne s'applique pas</em> aux ebooks numériques téléchargés. En achetant un
        ebook, l'acheteur reconnaît expressément que l'exécution du contrat a commencé dès la
        confirmation du paiement et renonce à son droit de rétractation.
      </p>
      <p>
        Les modalités de retour sont précisées sur notre <a href="/legal/retours">page Retours</a>.
      </p>

      <h2>8. Garanties légales</h2>
      <p>
        Les produits bénéficient de la garantie légale de conformité (articles L217-4 à L217-14 du
        Code de la consommation) et de la garantie contre les vices cachés (articles 1641 à 1649 du
        Code civil). Pour exercer une garantie, contactez-nous via la{" "}
        <a href="/legal/contact">page Contact</a>.
      </p>

      <h2>9. Responsabilité</h2>
      <p>
        BAYO ne saurait être tenue responsable des dommages indirects résultant de l'utilisation du
        Site ou de l'un des produits vendus. Les recettes proposées sont fournies à titre culinaire
        et culturel ; il appartient à chaque utilisateur·rice de vérifier les éventuelles allergies
        ou contre-indications alimentaires.
      </p>

      <h2>10. Litiges</h2>
      <p>
        Tout litige relatif à l'interprétation ou à l'exécution des présentes CGV sera soumis au
        droit français. Préalablement à tout recours contentieux, l'acheteur est invité à
        contacter le service client à l'adresse{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>
      <p>
        Conformément à l'article L612-1 du Code de la consommation, l'acheteur peut également
        recourir gratuitement au service de médiation de la consommation (plateforme européenne de
        règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>).
      </p>
    </LegalLayout>
  );
}
